
import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import styles from "./connectors.module.scss";

const ConnectorUnSuccesspage = () => {
    let connectorName:any =  GetItemFromStorage('selectedConName');

    return (
        <div className={styles.connectorErrorPage}>
            <h4 >{`Something went Wrong, Connecting ${connectorName}. Try again after Some Time.`}</h4>
        </div>
    );
}

export default ConnectorUnSuccesspage;
